import {MouseEventHandler} from 'react';

import './EditToggler.scss';
import {faPenCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface IProps {
  handleClick: MouseEventHandler<HTMLSpanElement>;
}

const EditToggler = ({handleClick}: IProps) => {
  return (
    <span className="toggler" data-testid="edit-toggler" title="edit pub" role="button" onClick={handleClick}>
      <FontAwesomeIcon icon={faPenCircle} />
    </span>
  );
};

export default EditToggler;
